export default {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { token, data }) {
    state.status = 'success';
    state.isApiKey = data.isApiKey;
    // if impersonating a user, save the original token
    state.originalToken = data.originalToken;
    state.isImpersonating = !!data.originalToken;
    state.token = token;
    state.tokenTimestamp = new Date();
    state.user = data.user;
    state.access = data.access;
    state.primaryScopeIds = data.primaryScopeIds;
    state.primaryTenantIds = data.primaryTenantIds;
    state.tenantId = data.tenantId;
    state.tenantIdThemeSetting = data.user.properties.tenantIdThemeSetting;
    localStorage.setItem('tokenTimestamp', new Date().toISOString());
    localStorage.setItem('token', token);
    localStorage.setItem('originalToken', data.originalToken);
    localStorage.setItem('userId', data.user.id);
  },
  auth_error(state) {
    state.status = 'error';
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
  },
  logout(state) {
    state.status = '';
    state.token = undefined;
    state.originalToken = undefined;
    state.isImpersonating = false;
    state.access = [];
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
  },
};
